import PropTypes from 'prop-types';
import { twJoin } from 'tailwind-merge';

import ErrorBoundary from 'components/ErrorBoundary';

import { getAdCssBackgroundColorProp } from 'lib/ads';

import { useTheme } from 'providers/ThemeProvider';

import ImagesWrapper from './ImagesWrapper';

const isDefaultBgColor = (bgcolor) => bgcolor?.includes('#000000') ?? false;

const TopbarAd = ({ bgcolor, description, image, mobileImage, url }) => {
  const { isDarkThemeActive } = useTheme();

  return (
    <ErrorBoundary>
      <div
        className={twJoin(
          'h-16 w-full lg:h-10',
          mobileImage ? 'block' : 'hidden lg:block',
          isDefaultBgColor(bgcolor) &&
            (isDarkThemeActive ? 'bg-neutral-low-500' : 'bg-white')
        )}
        style={{
          background: !isDefaultBgColor(bgcolor)
            ? getAdCssBackgroundColorProp(bgcolor)
            : null,
        }}
      >
        <ImagesWrapper
          description={description}
          image={image}
          mobileImage={mobileImage}
          url={url}
        />
      </div>
    </ErrorBoundary>
  );
};

TopbarAd.propTypes = {
  bgcolor: PropTypes.arrayOf(PropTypes.string),
  description: PropTypes.string,
  image: PropTypes.string,
  mobileImage: PropTypes.string,
  url: PropTypes.string.isRequired,
};

export default TopbarAd;
